// extracted by mini-css-extract-plugin
module.exports = {"postingCountContainer":"WorkspacePostingCount__postingCountContainer___qardd","postingCount":"WorkspacePostingCount__postingCount___Dn98E"};